/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type scheduleDelistAllMutationVariables = {
  listingId: string;
};
export type scheduleDelistAllMutationResponse = {
  readonly invsysScheduleDelistAll: {
    readonly success: boolean;
  };
};
export type scheduleDelistAllMutation = {
  readonly response: scheduleDelistAllMutationResponse;
  readonly variables: scheduleDelistAllMutationVariables;
};

/*
mutation scheduleDelistAllMutation(
  $listingId: String!
) {
  invsysScheduleDelistAll(listingId: $listingId) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'listingId',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'listingId',
            variableName: 'listingId',
          },
        ],
        concreteType: 'InvsysListingScheduleDelistAllResponse',
        kind: 'LinkedField',
        name: 'invsysScheduleDelistAll',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'scheduleDelistAllMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'scheduleDelistAllMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '7de8bfd85025b856762cb8abb23b365c',
      id: null,
      metadata: {},
      name: 'scheduleDelistAllMutation',
      operationKind: 'mutation',
      text: 'mutation scheduleDelistAllMutation(\n  $listingId: String!\n) {\n  invsysScheduleDelistAll(listingId: $listingId) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = '0b94701fc9fac9972fa281ee43dc8d9d';
export default node;
